module.exports = __webpack_public_path__ + "static/media/22713270_1629543147120870_5860065517027406298_o.671504f9.jpg";